import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { Box, Tooltip, Collapse, useMediaQuery, useTheme } from '@mui/material'
import { ExpandMore, ExpandLess } from '@mui/icons-material'
import { toggle } from '../../../actions/sidebar'
import renderIcon from '../../../utils/renderIcon'
import NavParent from './NavParent'

const NavButton = ({ text, url, nodes, icon }) => {
  const { active } = useSelector(state => state.ui.sidebar)
  const [open, setOpen] = useState(false)
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()
  const isMobile = useMediaQuery(useTheme().breakpoints.down('sm'))

  const isActive = location.pathname === url

  const onClick = (e) => {
    e.stopPropagation()
    if (nodes) {
      if (!active) dispatch(toggle(true))
      else setOpen(o => !o)
    } else {
      if (isMobile) dispatch(toggle(false))
      history.push(url)
    }
  }

  const button = (
    <Box
      onClick={onClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        mx: '8px',
        my: '2px',
        px: active ? '10px' : 0,
        height: '34px',
        borderRadius: '6px',
        cursor: 'pointer',
        justifyContent: active ? 'flex-start' : 'center',
        backgroundColor: isActive ? 'rgba(255,255,255,0.15)' : 'transparent',
        transition: 'background-color 0.15s',
        userSelect: 'none',
        '&:hover': {
          backgroundColor: isActive ? 'rgba(255,255,255,0.15)' : 'rgba(255,255,255,0.08)'
        }
      }}
    >
      {/* Icon */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          color: '#fff',
          '& svg': { fontSize: 19 }
        }}
      >
        {renderIcon(icon)}
      </Box>

      {/* Label */}
      {active && (
        <Box
          component='span'
          sx={{
            flex: 1,
            fontSize: '13.5px',
            fontWeight: isActive ? 500 : 400,
            color: '#fff',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            lineHeight: 1
          }}
        >
          {text}
        </Box>
      )}

      {/* Chevron for parent items */}
      {nodes && active && (
        <Box sx={{ display: 'flex', alignItems: 'center', color: 'rgba(255,255,255,0.35)', flexShrink: 0 }}>
          {open
            ? <ExpandLess sx={{ fontSize: 15 }} />
            : <ExpandMore sx={{ fontSize: 15 }} />}
        </Box>
      )}
    </Box>
  )

  return (
    <>
      {!active ? (
        <Tooltip title={text} placement='right' arrow>
          <span style={{ display: 'block' }}>{button}</span>
        </Tooltip>
      ) : button}

      {nodes && (
        <Collapse in={open && active} timeout='auto' unmountOnExit>
          <NavParent nodes={nodes} />
        </Collapse>
      )}
    </>
  )
}

export default NavButton
